const { getFile } = require("./files");

const loadIcon = file => new Promise((resolve, reject) => {
  try {
    let url = typeof file === "string" ? file : URL.createObjectURL(file)
    var img = new Image();
    img.onload = () => resolve(url);
    img.onerror = reject;
    img.src = url;
  } catch (err) {
    reject(err)
  }
});

const blob64 = (b64File, opts = {}) => {
  try {
    return new Blob([Buffer.from(b64File, "base64")], opts)
  } catch (err) {
    console.log("icon blob64", b64File, opts);
    console.error(err);
    throw err
  }
}

const hex = (hexFile, opts = {}) => {
  try {
    return new Blob([Buffer.from(hexFile, "hex")], opts)
  } catch (err) {
    console.log("icon hex", hexFile, opts);
    console.error(err)
    throw err
  }
}

async function getIcon(uid, timestamp) {
  try {
    let file = await getFile(uid, timestamp)
    if (!file) throw Error("file not found")
    else file = file.data
    return loadIcon(file);
  } catch (err) {
    return Promise.reject(err)
  }
}

module.exports = {
  getIcon,
  loadIcon,
  iconBase64: b64File => {
    if (b64File) {
      let blob = blob64(b64File)
      return loadIcon(blob);
    } else return null
  },
  iconHex: hexFile => {
    if (hexFile) {
      let blob = hex(hexFile)
      return loadIcon(blob)
    } else return null
  },
  iconSetter: (uid, setter, timestamp) => {
    getIcon(uid, timestamp)
      .then(setter)
      .catch(console.error);
  }
}
